<template>
  <div
    data-testid="inbox-v2-all-panel"
    class="tw-py-4 tw-px-6 tw-flex tw-flex-col tw-gap-4"
  >
    <template
      v-for="item in items"
      :key="`${item.category}-${item.name}-${item.item.kind}-${item.item.id}`"
    >
      <RemarkV2
        v-if="item.item.kind === 'remark-card'"
        :remark="item.item"
        show-context
        show-context-btn
        show-tags
        part-of="inbox"
      />
      <NotificationContent
        v-else
        type="CheckList"
        :communication-item="item.item"
      />
    </template>
    <div
      class="
        tw-mx-auto
        tw-my-4
        tw-font-medium
        tw-text-sm
        tw-text-sf-gray-light
        tw-text-center
      "
    ></div>
  </div>
</template>

<script setup>
import RemarkV2 from '@app/shared/vue/components/molecules/remark-v2/remark-v2.vue'
import NotificationContent from '@app/application/communication/screens/inbox/components/notification-content.vue'
import { computed } from 'vue'
import { useStore } from 'vuex'
import { COMPANY_CATEGORY } from '@app/application/communication/screens/inbox/store/utils'
import useGroupedFilteredCommunications from '@app/application/communication/screens/inbox/composables/use-grouped-filtered-communications'

const store = useStore()
const { groupedCommunication } = useGroupedFilteredCommunications()

const sections = computed(() =>
  [{ categoryId: COMPANY_CATEGORY }].concat(store.getters.sections)
)
const items = computed(() => {
  const result = []
  for (const section of sections.value) {
    if (groupedCommunication.value[section.categoryId]) {
      const names = Object.keys(
        groupedCommunication.value[section.categoryId]
      ).sort()
      for (const name of names) {
        result.push(
          ...groupedCommunication.value[section.categoryId][name].map(
            (item) => ({
              item,
              category: section.categoryId,
              name,
            })
          )
        )
      }
    }
  }
  return result
})
</script>
